import MainContent from '@/layouts/MainContent';
import { Tabs } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import AccountTab from './items/AccountTab';
import GeneralTab from './items/GeneralTab';
import NotificationTab from './items/NotificationTab';
import SellOnTheGoFareConfigurationTab from './items/SellOnTheGoFareConfigurationTab';
import './items/styles.less';
import TariffParameterTab from './items/TariffParameterTab';
import TicketSettingTab from './items/TicketSettingTab';
import TicketModificationSettingTab from './items/TicketModificationSettingTab';
import CancellationPolicyTab from './items/CancellationPoliciesTab';
const PAGE_TITLE = 'companySettingsPage_Title';

export default function CompanySettingsPage() {
  const { t } = useTranslation();

  return (
    <MainContent title={t(PAGE_TITLE)}>
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <Tabs>
          <Tabs.TabPane tab={t('companySettingsPage_Accounts')} key={'accounts'}>
            <AccountTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('companySettingsPage_General')} key={'general'}>
            <GeneralTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('companySettingsPage_Notifications')} key={'notifications'}>
            <NotificationTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('companySettingsPage_TicketSettings')} key={'ticket-settings'}>
            <TicketSettingTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('companySettingsPage_SellOnTheGo')} key={'sell-on-the-go'}>
            <SellOnTheGoFareConfigurationTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('companySettingsPage_TariffParameters')} key={'tariff-parameters'}>
            <TariffParameterTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('ticketModificationSetting_Title')} key={'ticket-modification'}>
            <TicketModificationSettingTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('cancellationPolicyPage_Title')} key={'cancellation -policy'}>
            <CancellationPolicyTab />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </MainContent>
  );
}
